.DashedInput {
  display: flex;
  box-sizing: border-box;
  background-color: transparent;
  border-radius: 0.4rem;
  border: 0.1rem var(--color-texts-low-contrast) dashed;
  font-size: 1.4rem;
  height: 3.2rem;
  min-height: 3.2rem;
  font-weight: 400;
  overflow: hidden;

  &:hover {
    border: 0.1rem var(--color-texts-middle-contrast) dashed;
    background-color: var(--color-surfaces-bg-elevation-3);

    & div {
      color: var(--color-texts-low-contrast);
    }
  }

  &[data-disabled='true'] {
    background: transparent;
    border-color: var(--color-texts-low-contrast);
  }
}

.DateSelectorWrapper {
  width: fit-content !important;

  & > div {
    padding: 0.6rem 0.8rem;
    font-size: 1.4rem;
    color: var(--color-texts-low-contrast);

    &:hover {
      background-color: var(--color-surfaces-bg-elevation-3);
    }
  }

  &[data-borderless='true'] {
    border-color: transparent;
    & > div {
      color: var(--color-texts-high-contrast);
    }
  }
}

.InputWrapper {
  display: flex;
  flex-direction: column;
  gap: .8rem;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
}
